import * as Yup from 'yup';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import {
    Link,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Button,
    Typography,
    Box,
    Fade,
    Grow,
    Slide
} from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { startLogin } from '../../store/actions/authActions';
import Cookies from 'js-cookie'
import { useEffect } from 'react';


const FormLogin = () => {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Activar animación del formulario
        const timer = setTimeout(() => {
            setShowForm(true);
        }, 200);
        return () => clearTimeout(timer);
    }, []);

    const LoginSchema = Yup.object().shape({
        email: Yup.string().email('El correo no es válido.').required('El Correo es requerido.'),
        password: Yup.string().required('La contraseña es requerida')
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: LoginSchema,
        onSubmit: () => {
        dispatch(startLogin(values?.email, values?.password,rememberMe))
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps,setFieldValue } = formik;

    const handleShowPassword = () => {
        setShowPassword((show) => !show);
    };
    useEffect(() => {
        const cookie = Cookies.get('auth');
        if(cookie){
            const usuarioRemember = JSON.parse(cookie)
            if(usuarioRemember){
                setFieldValue('email',usuarioRemember?.email)
                setFieldValue('password',usuarioRemember?.pass)
                if(usuarioRemember?.rememberMe){
                    setRememberMe(true)
                }
            }
        }
    }, [])

    return (
        <Box 
            sx={{
                width: '100%',
                maxWidth: 400,
                p: 3,
                position: 'relative',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
                    borderRadius: 3,
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    zIndex: -1
                }
            }}
        >
            <FormikProvider value={formik}>
                <Form autoComplete='off' noValidate onSubmit={handleSubmit}>
                    <Stack spacing={0}>
                        <Fade in={showForm} timeout={600}>
                            <div>
                                <Typography 
                                    sx={{
                                        color: '#000',
                                        textAlign: 'left',
                                        fontWeight: 'bold',
                                        background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }} 
                                    variant="h2"
                                >
                                    Bienvenido
                                </Typography>
                            </div>
                        </Fade>

                        <Slide direction="up" in={showForm} timeout={800}>
                            <Typography 
                                sx={{
                                    color: 'gray',
                                    textAlign: 'left',
                                    marginBottom: 7,
                                    opacity: 0.8
                                }} 
                                variant="h5"
                            >
                                Ingresa tus credenciales
                            </Typography>
                        </Slide>

                        <Grow in={showForm} timeout={1000}>
                            <div>
                                <Typography
                                    variant='h6'
                                    color='#000'
                                    sx={{ fontSize: 18 }}
                                >
                                    Email
                                </Typography>
                                <TextField
                                    fullWidth
                                    variant='standard'
                                    autoComplete="username"
                                    type="email"
                                    focused
                                    InputProps={{ 
                                        style: { 
                                            fontWeight: 'bold',
                                            fontSize: 15,
                                            color: '#000',
                                            transition: 'all 0.3s ease'
                                        } 
                                    }}
                                    {...getFieldProps('email')}
                                    error={Boolean(touched.email && errors.email)}
                                    sx={{
                                        "& .MuiInput-underline:after": {
                                            borderBottomColor: "#0364FF",
                                            borderWidth: 2
                                        },
                                        "& .MuiInput-underline:before": {
                                            borderBottomColor: "rgba(0, 0, 0, 0.2)",
                                            transition: 'border-color 0.3s ease'
                                        },
                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                            borderBottomColor: "#0364FF",
                                            borderWidth: 1
                                        },
                                        '& .MuiInputBase-root': {
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                transition: 'transform 0.2s ease'
                                            }
                                        }
                                    }}
                                    helperText={touched.email && errors.email}
                                />
                            </div>
                        </Grow>

                        <Grow in={showForm} timeout={1200}>
                            <div>
                                <Typography
                                    variant='h6'
                                    color='#000'
                                    sx={{ mt: 2, fontSize: 18 }}
                                >
                                    Contraseña
                                </Typography>
                                <TextField
                                    fullWidth
                                    autoComplete="current-password"
                                    variant='standard'
                                    focused
                                    type={showPassword ? 'text' : 'password'}
                                    {...getFieldProps('password')}
                                    InputProps={{
                                        style: {
                                            fontWeight: 'bold',
                                            fontSize: 15,
                                            color: '#000',
                                            borderBottomColor: 'red',
                                            transition: 'all 0.3s ease'
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton 
                                                    onClick={handleShowPassword} 
                                                    edge="end" 
                                                    sx={{
                                                        color: '#000',
                                                        transition: 'all 0.2s ease',
                                                        '&:hover': {
                                                            color: '#0364FF',
                                                            transform: 'scale(1.1)'
                                                        }
                                                    }}
                                                >
                                                    {!showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    sx={{
                                        "& .MuiInput-underline:after": {
                                            borderBottomColor: "#0364FF",
                                            borderWidth: 2
                                        },
                                        "& .MuiInput-underline:before": {
                                            borderBottomColor: "rgba(0, 0, 0, 0.2)",
                                            transition: 'border-color 0.3s ease'
                                        },
                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                            borderBottomColor: "#0364FF",
                                            borderWidth: 1
                                        },
                                        '& .MuiInputBase-root': {
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                transition: 'transform 0.2s ease'
                                            }
                                        }
                                    }}
                                    error={Boolean(touched.password && errors.password)}
                                    helperText={touched.password && errors.password}
                                />
                            </div>
                        </Grow>
                    </Stack>

                    <Fade in={showForm} timeout={1400}>
                        <Box display='flex' justifyContent='space-between' alignItems='center'>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onClick={() => setRememberMe(!rememberMe)}
                                        checked={rememberMe}
                                        sx={{
                                            color: '#000',
                                            transition: 'all 0.2s ease',
                                            '&.Mui-checked': {
                                                color: '#0364FF',
                                                transform: 'scale(1.1)'
                                            },
                                            '&:hover': {
                                                backgroundColor: 'rgba(3, 100, 255, 0.08)'
                                            }
                                        }}
                                    />
                                }
                                label="Recordar usuario"
                                componentsProps={{ 
                                    typography: { 
                                        sx: { 
                                            fontSize: 14,
                                            color: '#000',
                                            transition: 'color 0.2s ease'
                                        } 
                                    } 
                                }}
                                sx={{ marginTop: 2 }}
                            />
                            <Typography
                                sx={{
                                    color: '#0247B5',
                                    marginTop: 2,
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        color: '#0364FF',
                                        transform: 'scale(1.05)',
                                        textShadow: '0 2px 4px rgba(3, 100, 255, 0.3)'
                                    }
                                }}
                                onClick={() => navigate('/recover/password')}
                            >
                                Olvidé mi contraseña
                            </Typography>
                        </Box>
                    </Fade>

                    <Grow in={showForm} timeout={1600}>
                        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ my: 2 }}>
                            <Button
                                fullWidth
                                type="submit"
                                variant='contained'
                                sx={{
                                    background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                                    borderRadius: 20,
                                    color: '#fff',
                                    py: 1.5,
                                    fontSize: 16,
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 15px rgba(3, 100, 255, 0.4)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #0247B5 0%, #0364FF 100%)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 8px 25px rgba(3, 100, 255, 0.6)',
                                    },
                                    '&:active': {
                                        transform: 'translateY(0)',
                                        boxShadow: '0 4px 15px rgba(3, 100, 255, 0.4)',
                                    },
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: '-100%',
                                        width: '100%',
                                        height: '100%',
                                        background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
                                        transition: 'left 0.5s ease'
                                    },
                                    '&:hover::before': {
                                        left: '100%'
                                    }
                                }}
                            >
                                INICIAR SESIÓN
                            </Button>
                        </Stack>
                    </Grow>

                    <Fade in={showForm} timeout={1800}>
                        <div>
                            <Typography
                                sx={{
                                    fontSize: 13, 
                                    color: '#000', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    marginTop: 7,
                                    opacity: 0.7,
                                    transition: 'opacity 0.2s ease',
                                    '&:hover': {
                                        opacity: 1
                                    }
                                }}
                            >
                                Al utilizar Zeta-Crm usted acepta nuestros
                            </Typography>
                            <Link
                                href="#"
                                variant="body2"
                                color='inherit'
                                sx={{
                                    fontSize: 13, 
                                    color: '#0364FF', 
                                    display: 'flex', 
                                    justifyContent: 'center',
                                    width: { xs: '100%', md: 360 },
                                    textDecoration: 'none',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        color: '#0247B5',
                                        textShadow: '0 1px 3px rgba(3, 100, 255, 0.3)',
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            >
                                Términos y condiciones de uso
                            </Link>
                        </div>
                    </Fade>
                </Form>
            </FormikProvider>
        </Box>
    );
}

export default FormLogin